import Handlebars from "handlebars";
import {t} from "@lingui/core/macro";

// TODO(BrianG): We'd like to remove the need for this template soon.
// https://phabricator.khanacademy.org/D51483#inline-374539

export default () => Handlebars.compile(`<div class="hover-card-container">
    <div class="hover-card-triangle {{#if arrowOnRight}}right{{/if}}"></div>
    <div class="hover-card-content-container vertical-shadow">
        <div class="hover-card-content clearfix">
            <h4 class="pulls">
                ${t`Flags:`}
            </h4>
            <ul class="flagged-by-users">
            {{#each flags}}
                <li class="sample-content-link">
                    {{#if user}}
                        <a href="/devadmin/users/{{user}}">{{user}}</a>
                    {{else}}
                        ${t`Unknown or deleted user`}
                    {{/if}}
                    - <span class="flag-type">{{type}}</span>
                </li>
            {{/each}}
            </ul>
        </div>
    </div>
</div>`) as any;
